<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 3.27344H16.504C18.987 3.27344 21 5.28644 21 7.76944V16.7784C21 19.2604 18.987 21.2734 16.504 21.2734H7.496C5.013 21.2734 3 19.2604 3 16.7774V7.77344C3 5.28844 5.015 3.27344 7.5 3.27344V3.27344Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.1016 13.1733H16.5016"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.4984 8.67334H15.5534C14.0874 8.67334 12.8984 9.86234 12.8984 11.3283V12.2733V21.2733"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
